export const TEXT_MIN_WORDS = 2;
export const TEXT_MAX_WORDS = 100;

export const WORD_COUNT_HINT = `Minimum ${TEXT_MIN_WORDS} words, maximum ${TEXT_MAX_WORDS} words.`;

export const normalizeTextInput = (value) => String(value ?? "").replace(/^\s+/, "");

export const countWords = (value) =>
  String(value ?? "")
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;

export const limitTextInput = (value) => {
  const normalized = normalizeTextInput(value);
  const words = [...normalized.matchAll(/\S+/g)];
  if (words.length <= TEXT_MAX_WORDS) return normalized;

  const lastAllowedWord = words[TEXT_MAX_WORDS - 1];
  return normalized.slice(0, lastAllowedWord.index + lastAllowedWord[0].length);
};

export const validateWordCount = (value, label = "Text") => {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return `${label} is required`;
  const wordCount = countWords(trimmed);
  if (wordCount < TEXT_MIN_WORDS) {
    return `${label} must contain at least ${TEXT_MIN_WORDS} words.`;
  }
  if (wordCount > TEXT_MAX_WORDS) {
    return `${label} must not exceed ${TEXT_MAX_WORDS} words.`;
  }
  return "";
};
